<template>
    <div>
        <template v-if="needMultipleSelect">
            <multiselect
                :class="customClass"
                v-model="selectedTags"
                placeholder="Начните вводить значение..."
                select-label=""
                label="text"
                track-by="value"
                :multiple="true"
                :options="filteredOptions"
                :hide-selected="true"
                :loading="loading"
                :disabled="disabled"
            >
                <span slot="noResult">Ничего не найдено. Попробуйте снова...</span>
                <span slot="noOptions">Список пуст</span> <!-- Custom text for an empty list -->
            </multiselect>
        </template>
        <template v-else>
            <multiselect
                v-model="selectedPrepare"
                placeholder="Начните вводить значение..."
                select-label=""
                label="text"
                track-by="value"
                :options="filteredOptions"
                :hide-selected="true"
                :loading="loading"
                :disabled="disabled"
            >
                <span slot="noResult">Ничего не найдено. Попробуйте снова...</span>
                <span slot="noOptions">Список пуст</span> <!-- Custom text for an empty list -->
            </multiselect>
        </template>
    </div>
</template>

<script>
import { API_USERS } from '@/constants';

export default {
    props: {
        roles: { type: String, required: true },
        needNullElement: { type: Boolean, required: true },
        defaultSelectName: { type: String, required: false, default: 'Выберите пользователя' },
        needMultipleSelect: { type: Boolean, required: false, default: false },
        selected: { type: [String, Number], required: false },
        selectedArray: { type: [Array, String], required: false },
        additionalGetParameter: { type: [String, Number], required: false },
        additionalParameter: { type: Number, required: false, default: -1 },
        needAllElement: { type: Boolean, required: false, default: false },
        customClass: { type: String, default: '' },
        withoutFired: { type: Boolean, required: false, default: true },
        needOnlyOneFromDepartment: { type: Boolean, required: false, default: false },
        disabled: { type: Boolean, required: false, default: false },
    },
    data() {
        return {
            options: [],
            selectedLocal: '',
            selectedTags: [], // For multiple selection
            selectedPrepare: {}, // For single selection
            loading: false,
            filteredOptions: [] // Filtered options based on department logic
        }
    },
    watch: {
        selectedTags(tags) {
            this.selectedArrayLocal = tags.map(tag => tag.value);
            if (this.additionalParameter == -1) {
                this.$emit('set', this.selectedArrayLocal);
            } else {
                this.$emit('set', this.selectedArrayLocal, this.additionalParameter);
            }

            if (this.needOnlyOneFromDepartment) {
                this.filterOptionsByDepartment();
            } else {
                this.filteredOptions = this.options;
            }
        },
        selectedPrepare(element) {
            this.selectedLocal = element.value;
            if (this.additionalParameter == -1) {
                this.$emit('set', this.selectedLocal);
            } else {
                this.$emit('set', this.selectedLocal, this.additionalParameter);
            }
        },
        selectedArray(newVal) {
            if (this.needMultipleSelect && Array.isArray(newVal)) {
                this.selectedTags = this.options.filter(option => newVal.includes(option.value));
            } else if (!this.needMultipleSelect && newVal) {
                this.selectedPrepare = this.options.find(option => option.value === newVal) || {};
            }
        },
        selected(value) {
            if (value === '' && this.needAllElement) {
                this.selectedPrepare = { value: '', text: 'Все сотрудники' };
            }
        }
    },
    mounted() {
        this.getDataHandler();
    },
    methods: {
        async getDataHandler() {
            let additionalGetParameter = this.additionalGetParameter ? this.additionalGetParameter : '';
            const response = await api.call('get', API_USERS + `?roles=${this.roles}${additionalGetParameter}&withoutFired=${this.withoutFired}`);
            
            this.options = response.data;
            this.loading = false;

            if (this.needNullElement) {
                if (this.needAllElement) {
                    this.options.unshift({ value: '', text: 'Все сотрудники' });
                } else {
                    this.options.unshift({ value: null, text: this.defaultSelectName });
                }
            }

            this.filteredOptions = this.options;

            // Initialize selected values
            this.prepareSelectedLocal();

            // Handle filtering by department after data is fetched
            if (this.needOnlyOneFromDepartment) {
                this.filterOptionsByDepartment();
            }
        },
        filterOptionsByDepartment() {
            let selectedDepartments = [];

            // Gather departments from selected users
            this.selectedTags.forEach(tag => {
                if (Array.isArray(tag.departments)) {
                    selectedDepartments.push(...tag.departments);
                }
            });

            // Remove duplicate departments
            selectedDepartments = [...new Set(selectedDepartments)];

            // Filter options based on the department
            this.filteredOptions = this.options.filter(option => {
                if (!Array.isArray(option.departments) || option.departments.length === 0) {
                    return false;
                }

                // Ensure options from departments that aren't selected
                return option.departments.some(depId => !selectedDepartments.includes(depId));
            });
        },
        prepareSelectedLocal() {
            if (this.needMultipleSelect && Array.isArray(this.selectedArray)) {
                this.selectedTags = this.options.filter(option => this.selectedArray.includes(option.value));
            } else if (!this.needMultipleSelect && this.selected !== undefined && this.selected !== null) {
                const found = this.options.find(option => option.value === this.selected);
                this.selectedPrepare = found || {};
            }
        }
    }
}
</script>
